<template>
  <div class="data-list-container">
    <!-- <pre>
    school {{ schoolAdmin }}
    create {{ createModuleAction }}
    edit {{ editModuleAction }}
    view {{ viewModuleAction }}
    delete {{ deleteModuleAction }}
     </pre
    > -->
    <vs-popup
      class="popup"
      title="Column Rearrangement"
      :active.sync="columnRearrangementModal"
    >
      <RearrangeManagement
        @closeRearrangementModal="closeRearrangementModal"
        v-if="columnRearrangementModal"
        moduleProps="Students"
        :table_name="table_name"
        is_dynamic = "true"
      ></RearrangeManagement>
    </vs-popup>
    <ClientSummary :module_id="4" v-model="maximizeCard" />
    <vs-popup
      class="add_students_popup medium fixed_medium"
      classContent="popup-example"
      title="Add Student"
      :active.sync="addSideBar"
    >
      <!-- <div class="mt-6 flex items-center justify-between px-6">
        <h4>Add Client</h4>
      </div>
      <vs-divider class="mb-0" />
      <div class="p-6 pr-0 pt-2 pb-0"> -->
      <form data-vv-scope="add" class="sidebar-scrollable-form px-4">
        <div class="vx-row">
          <span style="color: green">{{ api_response_message }}</span>
          <div class="vx-col w-full">
            <form data-vv-scope="add">
              <vs-row class="my-2" vs-justify="space-between">
                <div class="inline-flex p-1">
                  <label class="pr-2">Parent with Minor</label>
                  <vs-switch v-model="multi_user_switch"/>
                </div>
                <!-- <vs-radio
                  v-model="client.multi_user"
                  color="primary"
                  :vs-value="1"
                  >Parent with Minor</vs-radio
                >
                <vs-radio
                  v-model="client.multi_user"
                  color="primary"
                  :vs-value="0"
                  >Individual</vs-radio
                > -->
              </vs-row>

              <div class="flex flex-wrap">
                <template v-for="field in staticFields">
                  <div class="p-1" :class="slugify(field.field_label) == 'first-name' || slugify(field.field_label) == 'middle-name' || slugify(field.field_label) == 'last-name' ? 'lg:w-1/3 sm:w-full' : slugify(field.field_label).includes('address') ? 'w-full' : 'lg:w-1/2 sm:w-full'" :key="field.id">
                    <div>
                      <label class="vs-input--label w-full" :class="slugify(field.field_label).includes('timezone') ? 'hidden' : ''"
                        >{{ field.field_label
                        }}<span v-if="field.enabled_parent" class="required"></span
                      ></label>
                      <vs-input
                        v-if="
                          field.field_name != 'platform_customer_countries_id' &&
                          field.field_name != 'platform_timezone_id' && field.field_name !=='dob'
                        "
                        v-validate="field.enabled_parent == true ? 'required' : ''"
                        v-model="client[field.field_name]"
                        class="custom_Input"
                        :name="field.field_label"
                        style="width: 100%"
                      />
                      <flat-pickr
                          v-if="field.field_name ==='dob'"
                          v-model="client[field.field_name]"
                          class="w-full"
                          :config="{maxDate: new Date()}"
                          :name="field.field_name"
                          :data-vv-name="field.field_label"
                          v-validate="field.enabled_parent == true ? 'required' : ''"
                        ></flat-pickr>
                    </div>
                    <v-select
                      v-if="
                        field.field_name == 'platform_customer_countries_id' &&
                        field.field_name != 'platform_timezone_id'
                      "
                      v-model="client[field.field_name]"
                      v-validate="field.enabled_parent == true ? 'required' : ''"
                      :reduce="(option) => option.id"
                      label="country_name"
                      :name="field.field_label"
                      :options="countryList"
                      style="width: 100%"
                    />


                    <!-- <v-select
                      v-if="
                        field.field_name != 'platform_customer_countries_id' &&
                        field.field_name == 'platform_timezone_id'
                      "
                      v-model="client[field.field_name]"
                      v-validate="field.enabled_parent == true ? 'required' : ''"
                      :reduce="(option) => option.timezone_id"
                      label="timezone"
                      :name="field.field_label"
                      :options="platformTimeZone"
                      style="width: 100%"
                    /> -->
                    <div
                      class="flex items-center"
                      style="color: rgba(var(--vs-primary), 1); font-size: 12px"
                      v-if="field.field_label == 'Phone'"
                    >
                      <span
                        style="font-size: 14px; margin-right: 2px"
                        class="material-icons-outlined"
                        >info</span
                      >Country code is mandatory.
                    </div>

                    <span
                      v-show="errors.has(`add.${field.field_label}`)"
                      class="text-danger ss"
                      >{{ errors.first(`add.${field.field_label}`) }}</span
                    >
                  </div>
                </template>
              </div>

              <vs-row v-if="addChildFrom" class="mt-2">
                <vs-card style="background: #ECF4F4;" v-for="(item, index) of client.children" :key="index">
                  <div
                    slot="header"
                    class="flex flex-wrap justify-between items-center"
                  >
                    <h5>Child Details</h5>
                    <div>
                      <vs-icon
                        color="danger"
                        icon="delete"
                        @click="handledeleteChild(index)"
                        style="margin-right: 10px; cursor: pointer;"
                      />
                      <vs-icon
                        icon-pack="feather"
                        :icon="
                          item.hide ? 'icon-chevron-down' : 'icon-chevron-left'
                        "
                        style="font-size: 20px; cursor: pointer;"
                        @click="item.hide = !item.hide"
                      />
                    </div>
                  </div>
                  <vs-checkbox
                    v-model="sameasparentAddress"
                    @change="abc(index)"
                    class="custom_Input mb-4"
                    :vs-value="`child_${index}`"
                    style="width: 100%"
                    >Same as Parent's Address</vs-checkbox
                  >
                  <!-- <vs-row
                      class="flex"
                      vs-justify="space-between"
                      vs-align="space-between"
                      style="float: right; margin-top: -5.2%"
                    >
                      <span class="sidebar-card-title">Child Details</span>
                      <div>
                        <vs-icon
                          color="danger"
                          icon="delete"
                          @click="handledeleteChild(index)"
                        />
                        <vs-icon
                          icon-pack="feather"
                          :icon="
                            item.hide
                              ? 'icon-chevron-down'
                              : 'icon-chevron-left'
                          "
                          style="font-size: 20px"
                          @click="item.hide = !item.hide"
                        />
                      </div>
                    </vs-row> -->
                  <div v-if="!item.hide">
                    <h6>{{ item.first_name }}</h6>
                  </div>
                  <div class="flex flex-wrap" v-else>
                    <template
                      v-for="childfield in staticChildFields"
                    >
                      <div class="p-1" :class="slugify(childfield.field_label) == 'first-name' || slugify(childfield.field_label) == 'middle-name' || slugify(childfield.field_label) == 'last-name' ? 'lg:w-1/3 sm:w-full' : slugify(childfield.field_label).includes('address') || slugify(childfield.field_label).includes('email') ? 'w-full' : 'lg:w-1/2 sm:w-full'" :key="childfield.id">
                        <label class="vs-input--label w-full" :class="slugify(childfield.field_label).includes('timezone') ? 'hidden' : ''"
                          >{{ childfield.field_label
                          }}<span
                            v-if="childfield.enabled_child"
                            class="required"
                          ></span
                        ></label>
                        <vs-input
                          v-if="
                          !['platform_customer_countries_id', 'platform_timezone_id', 'dob'].includes(childfield.field_name)"
                          v-model="item[childfield.field_name]"
                          v-validate="
                            childfield.enabled_child == true ? 'required' : ''
                          "
                          :data-vv-name="`child ${childfield.field_label}`"
                          :name="`child ${childfield.field_name}`"
                          class="custom_Input"
                          style="width: 100%"
                        />
                        <flat-pickr
                          v-if="childfield.field_name ==='dob'"
                          v-model="item[childfield.field_name]"
                          class="w-full"
                          :config="{maxDate: new Date()}"
                          :name="`child ${childfield.field_name}`"
                          :data-vv-name="`child ${childfield.field_label}`"
                          v-validate="childfield.enabled_child == true ? 'required' : ''"
                        ></flat-pickr>

                        <!-- <v-select
                          v-else-if="childfield.field_name === 'platform_timezone_id'"
                          v-model="item[childfield.field_name]"
                          v-validate="
                            childfield.enabled_child == true ? 'required' : ''
                          "
                          :reduce="(option) => option.timezone_id"
                          label="timezone"
                          :name="childfield.field_label"
                          :options="platformTimeZone"
                          style="width: 100%"
                          :placeholder="childfield.field_label"
                        /> -->

                        <v-select
                          v-if="
                            childfield.field_name ===
                              'platform_customer_countries_id' &&
                            childfield.field_name != 'platform_timezone_id'
                          "
                          v-model="client[childfield.field_name]"
                          :data-vv-name="`child ${childfield.field_label}`"
                          :name="`child ${childfield.field_name}`"
                          v-validate="
                            childfield.enabled_child == true ? 'required' : ''
                          "
                          :reduce="(option) => option.id"
                          label="country_name"
                          :options="countryList"
                          style="background: #fff; width: 100%"
                        />
                        <!-- <v-select
                          v-if="
                            childfield.field_name !=
                              'platform_customer_countries_id' &&
                            childfield.field_name == 'platform_timezone_id'
                          "
                          v-model="client[childfield.field_name]"
                          :data-vv-name="`child ${childfield.field_label}`"
                          :name="`child ${childfield.field_name}`"
                          v-validate="
                            childfield.enabled_child == true ? 'required' : ''
                          "
                          :reduce="(option) => option.timezone_id"
                          label="timezone"
                          :options="platformTimeZone"
                          style="width: 100%"
                        /> -->
                        <div
                          class="flex items-center"
                          style="
                            color: rgba(var(--vs-primary), 1);
                            font-size: 12px;
                          "
                          v-if="childfield.field_label == 'Phone'"
                        >
                          <span
                            style="font-size: 14px; margin-right: 2px"
                            class="material-icons-outlined"
                            >info</span
                          >Country code is mandatory.
                        </div>

                        <span
                          v-show="
                            errors.has(`add.child ${childfield.field_label}`)
                          "
                          class="text-danger"
                          >{{
                            errors.first(`add.child ${childfield.field_label}`)
                          }}</span
                        >
                      </div>
                    </template>
                  </div>
                </vs-card>
                <vs-row type="flex" vs-justify="flex-end">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-user-plus"
                    class="mt-2"
                    @click="handleAddMinor"
                  >Add Child</vs-button>
                </vs-row>
              </vs-row>

              <!-- For Dynamic Field required Labels-->
              <div class="mt-2">
                <dynamic-component
                  ref="children"
                  :custom_fields_required="custom_fields_required"
                  validatorScope="add"
                  v-model="dynamicFormObject"
                ></dynamic-component>
              </div>

              <!-- For Dynamic Field required Labels-->
            </form>
          </div>
        </div>

        <div class="text-center mt-5">
          <vs-button
            color="primary"
            type="filled"
            @click="create_client('saveandclose')"
            >Save</vs-button
          >
        </div>
      </form>
      <!-- </div> -->
      <!-- End chnages made by Sujay Ghosh -->
    </vs-popup>

    <!-- filter Side Bar -->
    <!-- <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="filterSidebar"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>FILTER Clients</h4>
        <feather-icon icon="XIcon" class="cursor-pointer" @click="filterSidebar = false" />
      </div>
      <vs-divider class="mb-0" />
      <form>
        <div class="p-6 pt-2">
          <div
            class="previous"
            v-for="(dynamicfilter, counter) in dynamicfilters"
            v-bind:key="counter"
          >
            <div class="vx-col w-full mt-5">
              <div style="display:flex;justify-content: space-between;">
                <label style="font-size: 12px; font-weight: 600;">Field Name</label>
                <vs-button
                  @click="delterFilter(counter)"
                  color="warning"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-delete"
                ></vs-button>
              </div>
              <select
                style="background: #fff !important; padding: 12px;"
                class="form-control vs-select--input vs-select--input-con mt-4"
                v-model="dynamicfilter.filterid"
              >
                <option
                  :value="index"
                  v-for="index in 5"
                  :key="index"
                  class="vs-select--options"
                >option{{index}}</option>
              </select>
              <label style="font-size: 12px; font-weight: 600;">Filter Condition</label>
              <select
                style="background: #fff !important; padding: 12px;"
                class="form-control vs-select--input vs-select--input-con mt-4"
                v-model="dynamicfilter.filtercondition"
              >
                <option
                  :value="index"
                  v-for="index in 5"
                  :key="index"
                  class="vs-select--options"
                >option{{index}}Conditions</option>
              </select>
              <vs-input
                placeholder="Choose Values"
                v-model="dynamicfilter.inputfieldvalue"
                class="mt-5 w-full"
                v-validate="'required'"
              />
            </div>
          </div>

          <vs-button
            color="primary"
            style="float:right"
            class="mt-3"
            type="filled"
          >Add More Filters</vs-button>

          <vs-divider class="mt-5 mb-2" />

          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2">
              <vs-input
                placeholder="Provide Filter Name"
                class="mt-5 w-full"
                v-validate="'required'"
                v-model="customFilterName"
              />
            </div>
          </div>

          <vs-divider class="mt-5 mb-2" />
          <div class="vx-row mt-5">
            <div class="vx-col w-full" style="text-align: center;">
              <vs-button
                primary
                style="font-weight: 700;"
                class="mr-3"
                @click="handleSaveFilter"
              >Submit</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-sidebar>-->
    <!-- {{tableData}} -->
    <!-- {{allData}} -->
    <filter-sidebar
      :isSidebarActive="filterSidebarBoolean"
      :fieldtabledata="fieldtabledata"
      :filterconditiondata="filterconditiondata"
      platformmodulename="Students"
      @closedsidebarevent="filterSidebarEvent"
      :name="table_name"
    ></filter-sidebar>
    <!-- view SIdebar -->
    <vs-sidebar
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="get_client_sidebar_view"
      style="overflow-y: scroll"
    >
      <view-client-sidebar
        :isSidebarActive="get_client_sidebar_view"
        :get_client_sidebar_data="get_client_sidebar_data"
        :timelineData="timelineData"
        @closeSidebar="handleViewSidebar"
      ></view-client-sidebar>
    </vs-sidebar>

    <vx-card title="" class="mb-4">
      <div
        v-if="isRowSelected"
        style="font-size: 13.8px; padding: 7px; float: right"
      >
        <vs-button
          class="custom-btn1"
          type="border"
          style="border-radius: 5px 0px 0px 5px"
          :disabled="!isRowSelected"
          @click="handleExport"
          >Export</vs-button
        >
        <vs-button
          class="custom-btn1"
          type="border"
          :disabled="!isRowSelected"
          @click="(bulkEmailModal = !bulkEmailModal), bulkMailAdd()"
          >Bulk Email</vs-button
        >
        <!-- <vs-button class="custom-btn1" type="border" :disabled="!isRowSelected"
          >Assign</vs-button
        > -->
        <vs-button
          class="custom-btn1"
          type="border"
          :disabled="!isRowSelected"
          @click="bulkupdateModal = !bulkupdateModal"
          >Update Field</vs-button
        >
        <vs-button
          v-if="checkDeletePermission()"
          class="custom-btn1"
          type="border"
          @click="openConfirmationModal"
          :disabled="!isRowSelected"
          >Delete</vs-button
        >
        <!-- <vs-dropdown
          vs-custom-content
          vs-trigger-click
          class="cursor-pointer"
          :disabled="!isRowSelected"
        >
          <vs-button
            class="custom-btn1 btnx"
            type="border"
            :disabled="!isRowSelected"
          >
            More
            <i
              class="material-icons"
              style="font-size: 12px; vertical-align: middle; font-weight: 600"
              >keyboard_arrow_down</i
            >
          </vs-button>
          <vs-dropdown-menu>
            <vs-dropdown-item>option 1</vs-dropdown-item>
            <vs-dropdown-item>option 2</vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown> -->
        <!-- <vs-button
          class="custom-btn1"
          type="border"
          style="border-radius: 0px 5px 5px 0px"
          :disabled="!isRowSelected"
        >
          <i
            class="material-icons"
            style="font-size: 12px; vertical-align: middle; font-weight: 600"
            >sync</i
          >
        </vs-button> -->
      </div>

      <vs-row class="mt-2">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <div class="md:w-1/2 w-full p-1">
            <vs-input
              placeholder="Search"
              class="w-full"
              v-model="search"
              @keyup="searchFun"
              style="width: 100%"
            />

            <!--  <vs-select
            v-model="select_filter_id"
            autocomplete
            label="Select Filter"
            class="selectExample"
            @change="getFilterByLead()"
            style="width: 100%"
          >
            <vs-select-item
              v-for="user_filter in user_main_filter"
              :key="user_filter.id"
              :value="user_filter"
              :text="user_filter.filter_name"
            />
          </vs-select> -->
          </div>
          <!-- {{user_main_filter}} -->
          <!-- <v-select class="p-2" label="FilterName" :options="filterList" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
          <div class="p-1" v-if="checkEditPermission()">
            <!-- <vs-tooltip color="primary" text="Filter" position="top">
              <vs-button
                class="btn-w-icon"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-filter"
                @click="filterSidebarBoolean = !filterSidebarBoolean"
              />
            </vs-tooltip> -->
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Filter View" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="overallSearch"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <rect width="18" height="18" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14ZM11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.1465 16.3536L13.1465 14.3536L13.8536 13.6465L15.8536 15.6465L15.1465 16.3536Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H15C16.3807 0.5 17.5 1.61929 17.5 3V14.5H16.5V3C16.5 2.17157 15.8284 1.5 15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V15C1.5 15.8284 2.17157 16.5 3 16.5H13.5V17.5H3C1.61929 17.5 0.5 16.3807 0.5 15V3Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.5 5.5H1.5V4.5H16.5V5.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 8.5H1.5V7.5H7.5V8.5ZM16.5 8.5H15V7.5H16.5V8.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.5 11.5H1.5V10.5H6.5V11.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 14.5H1.5V13.5H7.5V14.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.5 16.5V5H5.5V16.5H4.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
          <div class="p-1" v-if="checkEditPermission()">
            <vs-tooltip color="primary" text="Rearrange Column" position="top">
              <vs-button
                @click="columnRearrangement"
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                icon="published_with_changes"
              >
              </vs-button>
            </vs-tooltip>
          </div>
          <div class="p-1" v-if="checkEditPermission()">
            <vs-tooltip color="primary" text="Import CSV/ XLS" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="excelModal()"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H22C18.6863 43 16 40.3137 16 37V24.5H18V37C18 39.2091 19.7909 41 22 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 28V32C10 34.2091 11.7909 36 14 36H24V38H14C10.6863 38 8 35.3137 8 32V28H10Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.36396 28.8284L4.41421 33.7782L3 32.364L9.36396 26L15.7279 32.364L14.3137 33.7782L9.36396 28.8284Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>

          <div class="p-1">
            <vs-tooltip color="primary" text="Export Template" position="top">
              <vs-button
                @click="exportApi"
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H18C14.6863 43 12 40.3137 12 37V24.5H14V37C14 39.2091 15.7909 41 18 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 26V30C8 32.2091 9.79086 34 12 34H22V36H12C8.68629 36 6 33.3137 6 30V26H8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.8995 34.6569L16.9498 39.6066L18.364 41.0208L24.728 34.6569L18.364 28.2929L16.9498 29.7071L21.8995 34.6569Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
        </vs-col>
        <!-- <vs-col vs-sm="12" vs-xs="12" vs-lg="4" class="p-2">
          <vs-button color="primary" type="filled">Kanban View</vs-button>
        </vs-col> -->

        <vs-col vs-sm="12" vs-xs="12" vs-lg="4">
          <vs-row vs-type="flex" vs-justify="flex-end" vs-align="center">
            <!-- <vs-button
              class="btnx"
              style="margin-right: 1%"
              @click="columnRearrangement"
            >
              Resize Modal
            </vs-button> -->
            <vs-button
              class="btnx add-client"
              @click="addClient"
              v-if="this.checkCreatePermission()"
              >Add Student</vs-button
            >
            <!-- <vs-button color="primary" type="border" class="mr-2">Widget Panel</vs-button> -->
            <!-- <div class="dropdown-button-container">
              <vs-dropdown
                style="float: right; cursor: pointer"
                vs-custom-content
                vs-trigger-click
              >
                <vs-button
                  class="btn-w-icon"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-settings"
                />
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    class
                    :to="{
                      name: 'field-re-arrange',
                      params: { module_name: 'leads' },
                    }"
                    >Customize Columns</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    class
                    :to="{
                      name: 'custom-value-list-view',
                      params: { modelname: 'ClientUser' },
                    }"
                    >Create Custom Fields</vs-dropdown-item
                  >
                </vs-dropdown-menu>
              </vs-dropdown>
            </div> -->
          </vs-row>
        </vs-col>
      </vs-row>
      <!-- table -->
    </vx-card>
    <div v-if="bulkupdateModal == true">
      <UpdateModal
        :platformTimeZone="platformTimeZone"
        :custom_fields_required="custom_fields"
        :countryList="countryList"
        :displayListofdata="displayListofdata"
        @bulkupdatelist="bulkupdatelist"
      ></UpdateModal>
    </div>
    <vs-popup class="popup" title="Mail" :active.sync="bulkEmailModal">
      <BulkEmail
        :mail_id="mail_id"
        @mail_body="mail_body"
        v-if="bulkEmailModal"
      ></BulkEmail>
    </vs-popup>
    <div v-if="overallSearchHolder">
      <vs-card class="cstm_vx_card mb-4">
        <div slot="header" class="flex flex-wrap justify-between items-center">
          <h4>Filter View</h4>
          <vs-button @click="filterSidebarBoolean = !filterSidebarBoolean">Add Custom Filter</vs-button>
        </div>
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="sm:block block lg:flex"
          >
            <div class="lg:w-1/3 w-full p-1">
              <v-select
                placeholder="Select View"
                v-if="user_main_filter"
                class="w-full"
                label="filter_name"
                :options="user_main_filter"
                :reduce="(item) => item.id"
                :clearable="false"
                v-model="select_filter_id"
                @input="getFilterByLead()"
              >
              </v-select>
            </div>
            <div class="lg:w-1/3 w-full p-1">
              <v-select
                placeholder="Student Type"
                class="w-full"
                :options="ClientType"
                v-model="searchByClientType"
                label="name"
                :reduce="(option) => option.value"
              >
              </v-select>
            </div>
            <div class="lg:w-2/3 w-full p-1">
              <v-select
                placeholder="Select tag to search"
                v-model="tagSelected"
                class="w-full"
                multiple
                label="name"
                taggable
                :create-option="
                  (option) => ({ id: option, label: option, name: option })
                "
                :options="tagModuleWise"
                :clearable="false"
                data-vv-name="tag_list"
                name="tag_list"
              >
              </v-select>
            </div>
            <div class="flex p-1">
              <vs-button
                class="mx-2 includeIcon includeIconOnly"
                @click="searchByfilter"
                >Go</vs-button
              >
              <vs-tooltip color="primary" text="Reset Filters" position="top">
                <vs-button
                  type="border"
                  icon-pack="feather"
                  @click="resetSearch"
                  icon="icon-refresh-cw"
                ></vs-button>
              </vs-tooltip>
            </div>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>
    <div>
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="limitedTableList"
        rowSelection="multiple"
        suppressRowClickSelection="true"
        colResizeDefault="true"
        :style="{ minHeight: meta.limit * 48 + 75 + 'px' }"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @cell-value-changed="onCellValueChanged"
        @row-selected="CellvalueSelectDeselect"
        @cell-clicked="cellSingleClicked"
        @columnMoved="handleRearrangement"
        @columnVisible="handleColumnHideShow"

        :enableRtl="$vs.rtl"
        @sortChanged="sortFun"
      ></ag-grid-vue>
       <!-- @columnResized="resizeChanges($event)" -->
      <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
        <vs-col
          vs-xs="12"
          vs-sm="6"
          vs-lg="4"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
        >
          <!-- page limit select view -->
          <ItemsPerTableDropdown
            :tableName="table_name"
            @change="(pageLimit) => (pageLimitSet = pageLimit)"
          />
        </vs-col>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
          <pagination
            style="float: right"
            :meta="meta"
            @page-change="handlePageChange"
          />
        </vs-col>
      </vs-row>
    </div>
    <vs-popup class="popup" title="Excel Upload" :active.sync="excelPopUp">
      <excel-modal
        v-if="excelPopUp"
        :module_id="platform_module_id"
        @uploadSuccess="uploadSuccess"
        model="client"
      ></excel-modal>
    </vs-popup>
    <vs-popup
        classContent="popup-example"
        title="Please Confirm"
        :active.sync="showPopUpBool"
      >
        <h4>Are you sure to delete selected students?</h4>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click="handleBulkDelete">Confirm</vs-button>
          <vs-button type="border" color="danger" @click="showPopUpBool = false"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
  </div>
</template>
<script>
import axios from 'axios'
import { exportApiDownload } from '@/api/excelApi'
import CountryCell from './Countrycell.vue'
import DynamicSelect from './DynamicSelect.vue'
import DynamicBoolean from './DynamicBoolean.vue'
import DynamicDate from './DynamicDate'
import CreatedAtCell from './CreatedAtCell'
import PhoneImageCell from './PhoneImageCell'
import ExcelModal from '@/components/excel/ExcelModal.vue'
import { GeneralMixins } from '@/mixins/generalMixins/GeneralMixins.js'
import { Tag } from '@/mixins/tag/tag'
import ViewClientSidebar from './ViewClientSidebar'
import BulkEmail from '../email/composeEmail.vue'
import TagShow from '../leads/TagShow'
import FullNameCell from './FullNameCell.vue'
import ClientSummary from '../analytics/summeryLIst'
import UpdateModal from '@/components/common/UpdateModal.vue'
import router from '@/router'
import Prism from 'vue-prism-component'
import {
  getPersonaDetails,
  createClient,
  clientList,
  deleteClient,
  getFilterList,
  updateClient,
  bulkUpdateApi,
  bulkEmailApi,
  fetchClientBySearch
} from '@/api/client'
import { fetchCustomStaticFields } from '@/api/customfield'
import { ClientMixin } from './mixin/ClientMixin'
import { GetCountryList } from '@/api/common'

import { get_fields_filters } from '@/api/filter'
// import {
//   role_list,
//   update_user,
// } from '@/api/student'

import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VxTimeline from '@/components/timeline/VxTimeline.vue'
import vSelect from 'vue-select'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from './CellRendererActions'
import ToggleActions from './ToggleActions'
import EditActions from './EditActions'
import DeleteActions from './DeleteActions'
import PreviewActions from './PreviewActions'
import EmailAction from './EmailAction'
// import StatusCell from './statuscell'
import { mapGetters, mapActions } from 'vuex'
import Pagination from '@/components/common/pagination'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import FilterSidebar from '@/components/common/filter-sidebar'
import DynamicComponent from '@/components/common/DynamicComponent'

import { DynamicField } from '@/mixins/dynamic-field'
import { DynamicFilter } from '@/mixins/dynamic-filter'
import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'
import { arrangeColumn, fetchField } from '@/api/columnrearrange'
import RearrangeManagement from '@/views/pages/customFieldRearrage/RearrangeManagement'
import CoursesListAction from './CoursesListAction'
import TeachersListAction from './TeachersListAction'

export default {
  components: {
    Prism,
    VxTimeline,
    vSelect,
    AgGridVue,
    CellRendererActions,
    ToggleActions,
    EditActions,
    DeleteActions,
    PreviewActions,
    flatPickr,
    StatisticsCardLine,
    // StatusCell,
    Pagination,
    FilterSidebar,
    DynamicComponent,
    UpdateModal,
    ClientSummary,
    TagShow,
    FullNameCell,
    PhoneImageCell,
    BulkEmail,
    ViewClientSidebar,
    RearrangeManagement,
    ExcelModal,
    CreatedAtCell,
    DynamicDate,
    DynamicBoolean,
    DynamicSelect,
    CountryCell,
    EmailAction,
    CoursesListAction,
    TeachersListAction
  },
  mixins: [
    DynamicField,
    DynamicFilter,
    PermissionMiddleware,
    ClientMixin,
    Tag,
    GeneralMixins
  ],

  data () {
    return {
      table_name:'student_list',
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      search: '',
      excelPopUp: false,
      staticFields: [],
      columnRearrangementModal: false,
      staticChildFields: [],
      searchByClientType: '',
      ClientType: [
        {
          name: 'Individual',
          value: 'individual'
        },

        {
          name: 'Parent',
          value: 'parent'
        },
        {
          name: 'Child',
          value: 'child'
        }
      ],
      platform_module_id: 4,
      overallSearchHolder: false,
      sameasparentAddress: [],
      selected_lead_is: [],
      mail_id: [],
      bulkEmailModal: false,
      showPopUpBool: false,
      displayListofdata: [],
      bulkupdateModal: false,
      addChildFrom: false,
      multi_user_switch: false,
      client: {
        client_persona_id: null,
        lead_id: null,
        multi_user: 0,
        first_name: null,
        middle_name: null,
        last_name: null,
        email: null,
        mobile: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        platform_customer_countries_id: 1,
        platform_timezone_id: null,
        children: []
      },
      personaList: [],
      staticDisplayField: [
        {
          field_label: 'First Name',
          field_name: 'first_name'
        },
        {
          field_label: 'Last Name',
          field_name: 'last_name'
        },
        {
          field_label: 'Address 1',
          field_name: 'address1'
        },
        {
          field_label: 'Address 2',
          field_name: 'address2'
        },
        {
          field_label: 'State',
          field_name: 'state'
        },
        {
          field_label: 'Country',
          field_name: 'platform_customer_countries_id'
        },
        {
          field_label: 'City',
          field_name: 'city'
        },
        {
          field_label: 'Zip',
          field_name: 'zip'
        }
      ],
      userType: [
        {
          value: 0,
          label: 'Individual'
        },
        {
          value: 1,
          label: 'Parent + child'
        }
      ],
      countryList: [],
      first_name: '',
      email: '',
      phone: '',
      last_name: '',
      user_role_id: '',
      address: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: ''
      },

      options1: [],

      errorCount: 0,
      api_response_message_show: false,
      api_response_message: '',
      // End
      table_switch: false,
      addSideBar: false,
      viewSideBar: false,
      filterSidebar: false,
      maximizeCard: true,
      // custom_fields: [],
      // custom_fields_required: [],

      //dynamicfilters
      // fieldtabledata:[],
      // filterconditiondata:[],
      filterSidebarBoolean: false,
      firstData: [],
      // user_main_filter:
      //   {
      //     id:'all',
      //     users_id:null,
      //     filter_name:'All',
      //     platform_modules_id:null
      //   },
      select_filter_id: '',
      //
      // dynamicfilters: [
      //   {
      //     filterid: '',
      //     filtercondition: '',
      //     inputfieldvalue: ''
      //   }
      // ],

      //for getting custom field
      selected: [],
      /// filter work
      customFilterName: '',
      dynamicFormObject: {},

      /// filter
      //select checkbox
      select_All: false,
      //
      // pagination
      //
      // pagelimit
      pageLimitOPtion: [
        {
          name: 5,
          value: 5
        },
        {
          name: 10,
          value: 10
        },
        {
          name: 20,
          value: 20
        }
      ],
      pageLimitSet: null,
      //
      tableList: [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      timelineData: [
        {
          color: 'primary',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls1',
          time: '25 Days Ago'
        },
        {
          color: 'warning',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls2',
          time: '15 Days Ago'
        },
        {
          color: 'success',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls3',
          time: '20 mins ago'
        },
        {
          color: 'primary',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls4',
          time: '25 Days Ago'
        },
        {
          color: 'warning',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls5',
          time: '15 Days Ago'
        },
        {
          color: 'success',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls6',
          time: '20 mins ago'
        }
      ],
      tableData: [],
      // allData:[],
      selected_data: null,
      //Ag Grid Table
      gridApi: {},
      gridOptions: {
        accentedSort: true
      },
      gridColumnApi: {},
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
        // autoHeight: true
      },
      columnApi: null,
      rowData: null,
      context: {},
      components: {
        CellRendererActions,
        ToggleActions,
        EditActions,
        DeleteActions,
        PreviewActions,
        TagShow,
        FullNameCell,
        PhoneImageCell,
        CreatedAtCell,
        DynamicDate,
        DynamicBoolean,
        DynamicSelect,
        CountryCell,
        EmailAction
        // StatusCell
      },
      columnDefsBackup: [],
      columnDefs: [],
      // columnDefs: [
      //   {
      //     headerName: '',
      //     minWidth: 60,
      //     field: 'isSelected',
      //     filter: true,
      //     checkboxSelection: true,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     },
      //     headerCheckboxSelectionFilteredOnly: true,
      //     headerCheckboxSelection: true
      //   },
      //   {
      //     headerName: '#',
      //     field: 'row_index',
      //     filter: true,
      //     minWidth: 60,
      //     resizable: true,
      //     editable: false
      //   },
      //   {
      //     headerName: 'First Name',
      //     field: 'basic_details.first_name',
      //     minWidth: 150,
      //     filter: true
      //   },
      //   {
      //     headerName: 'Middle Name',
      //     field: 'basic_details.middle_name',
      //     filter: true,
      //     minWidth: 150,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     }
      //   },
      //   {
      //     headerName: 'Last Name',
      //     field: 'basic_details.last_name',
      //     filter: true,
      //     minWidth: 150,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     }
      //   },
      //   {
      //     headerName: 'Email',
      //     field: 'basic_details.email',
      //     filter: true,
      //     minWidth: 150,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     }
      //   },
      //   {
      //     headerName: 'Phone',
      //     field: 'basic_details.mobile',
      //     filter: true,
      //     minWidth: 150,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     }
      //   },
      //   {
      //     headerName: 'User Type',
      //     // field: 'basic_details.user_type',
      //     valueGetter: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.user_type === 'Children') {
      //         return 'Child'
      //       } else {
      //         return params.data.basic_details.user_type
      //       }
      //     },
      //     filter: true,
      //     minWidth: 150,
      //     editable: false
      //     // editable: (params) => {
      //     //   if (params.data.basic_details.active_user === '1') {
      //     //     return true
      //     //   } else {
      //     //     return false
      //     //   }
      //     // }
      //   },
      //   {
      //     headerName: 'Root User',
      //     // field: 'basic_details.root_user',
      //     // valueFormatter:(params) => { return params.user_type.toUpperCase() },
      //     valueGetter: (params) => {
      //       if (params.data.basic_details.root_user === 'SELF') {
      //         return 'Self'
      //       } else {
      //         return params.data.basic_details.root_user
      //       }
      //     },
      //     filter: true,
      //     minWidth: 150,
      //     editable: false
      //   },
      //   {
      //     headerName: 'Address1',
      //     field: 'basic_details.address.address1',
      //     filter: true,
      //     minWidth: 150,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     }
      //   },
      //   {
      //     headerName: 'Address2',
      //     field: 'basic_details.address.address2',
      //     filter: true,
      //     minWidth: 150,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     }
      //   },
      //   // {
      //   //   headerName: 'City',
      //   //   field: 'basic_details.address.city',
      //   //   filter: true,
      //   //   minWidth: 150,
      //   //   editable: (params) => {
      //   //     if (params.data.basic_details.active_user === '1') {
      //   //       return true
      //   //     } else {
      //   //       return false
      //   //     }
      //   //   }
      //   // },
      //   {
      //     headerName: 'County/State',
      //     field: 'basic_details.address.state',
      //     filter: true,
      //     minWidth: 150,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     }
      //   },
      //   {
      //     headerName: 'Postcode/Zip',
      //     field: 'basic_details.address.zip',
      //     filter: true,
      //     minWidth: 150,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     }
      //   },
      //   {
      //     headerName: 'Country',
      //     field: 'basic_details.address.country.country_name',
      //     filter: true,
      //     minWidth: 150,
      //     editable: false
      //     // editable: (params) => {
      //     //   if (params.data.basic_details.active_user === '1') {
      //     //     return true
      //     //   } else {
      //     //     return false
      //     //   }
      //     // }
      //   },
      //   {
      //     headerName: 'City',
      //     field: 'basic_details.address.city',
      //     filter: true,
      //     minWidth: 125,
      //     editable: (params) => {
      //       if (!this.checkEditPermission()) {
      //         return false
      //       }
      //       if (params.data.basic_details.active_user === '1') {
      //         return true
      //       } else {
      //         return false
      //       }
      //     }
      //   },
      //   {
      //     headerName: 'Tags',
      //     field: 'tags',
      //     filter: true,
      //     minWidth: 150,
      //     editable: false,
      //     cellRendererFramework: 'TagShow'
      //   }
      //   /*  {
      //     headerName: 'Active',
      //     field: 'actionData',
      //     width: 100,
      //     editable: false,
      //     filter: false,
      //     cellRendererFramework: 'ToggleActions'
      //   } */
      //   // {
      //   //   headerName: 'Edit',
      //   //   field: 'actionData',
      //   //   width: 80,
      //   //   editable: false,
      //   //   filter: false,
      //   //   cellRendererFramework: 'EditActions'
      //   // },
      //   // {
      //   //   headerName: 'Delete',
      //   //   field: 'actionData',
      //   //   width: 100,
      //   //   editable: false,
      //   //   filter: false,
      //   //   cellRendererFramework: 'DeleteActions'
      //   // },
      //   // {
      //   //   headerName: 'Preview',
      //   //   field: 'actionData',
      //   //   width: 110,
      //   //   editable: false,
      //   //   filter: false,
      //   //   cellRendererFramework: 'PreviewActions'
      //   // }
      //   // {
      //   //   headerName: 'Action',
      //   //   field: 'actionData',
      //   //   width: 100,
      //   //   editable: false,
      //   //   filter: false,
      //   //   cellRendererFramework: 'CellRendererActions'
      //   // }
      // ],
      /// bulk buttons
      isRowSelected: false,
      active_status_list: [],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1,
        limit: 10
      }
    }
  },
  watch: {
    columnRearrangementModal () {
      if (!this.columnRearrangementModal) {
        this.fetchingDynamicFieldAndFilter()
        this.fetchDisplayFields(
          'Students',
          this.$store.getters.customerId
        ).then(() => {
          this.gridOptions.api.sizeColumnsToFit()
        })
        this.searchByfilter()
        // this.gridOptions.api.refreshCells()
      }
    },
    tagSelected () {
      this.filterTagList(this.platform_module_id)
    },
    pageLimitSet () {
      this.handlePageChange(1)
    },
    multi_user_switch () {
      this.client.multi_user = this.multi_user_switch === true ? 1 : 0
    },
    client: {
      deep: true,
      handler () {
        if (this.client.multi_user === 1) {
          this.addChildFrom = true
        } else {
          this.addChildFrom = false
        }
      }
    },
    addChildFrom () {
      if (!this.addChildFrom) {
        this.client.children = [
          {
            first_name: null,
            middle_name: null,
            last_name: null,
            email: null,
            mobile: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            zip: null,
            platform_customer_countries_id: 1,
            platform_timezone_id: null,
            dob: null,
            hide: true
          }
        ]
      }
    },

    get_client_deleted_id () {
      // if (this.get_client_deleted_id) {      //   const queryParams = this.$route.query || {}
      //   this.query_page.page = queryParams.page || 1
      //   this.query_page.limit = queryParams.limit || 10
      //   this.fetch_list(this.query_page)
      // }

      if (this.get_client_deleted_id) {
        const table = this.tableData
        const dlt_id = table.findIndex(
          (item) => item.basic_details.client_users_id === this.get_client_deleted_id
        )
        if (table[dlt_id].basic_details.user_type === 'Parent') {
          if (table[dlt_id].children.length > 0) {
            for (const chld of table[dlt_id].children) {
              const childIndex = table.findIndex(
                (item) => item.basic_details.client_users_id ===
                  chld.address.client_users_id
              )
              table.splice(childIndex, 1)
            }
            const parentIndex = table.findIndex(
              (item) => item.basic_details.client_users_id ===
                this.get_client_deleted_id
            )
            table.splice(parentIndex, 1)
          } else {
            table.splice(dlt_id, 1)
          }
        } else {
          table.splice(dlt_id, 1)
        }
        // table[dlt_id].basic_details.user_type ==='Parent'

        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.tableData = table

        if (this.tableData.length === 0 && !this.meta.next_page_url) {
          this.handlePageChange(this.meta.current_page - 1)
        } else {
          this.handlePageChange(this.meta.current_page)
        }
      }
    },
    get_client_toggle_data: {
      deep: true,
      handler () {
        //
        const table = this.tableData
        table.map((element) => {
          if (
            element.basic_details.client_users_id ===
            this.get_client_toggle_data.row_details.basic_details
              .client_users_id
          ) {
            element.basic_details.active_user = this.get_client_toggle_data
              .toggle
              ? '1'
              : '0'
            element.actionData.toggle = this.get_client_toggle_data.toggle
          }
        })
        if (
          !this.get_client_toggle_data.toggle &&
          this.get_client_toggle_data.row_details.basic_details.user_type ===
            'Parent'
        ) {
          const queryParams = this.$route.query || {}
          this.query_page.page = queryParams.page || 1
          this.query_page.limit = queryParams.limit || 10
          this.fetch_list()
        }

        this.tableData = table
      }
    }
  },
  async created () {
    await this.fetchCountry()
    await this.fetchingDynamicFieldAndFilter()
    await this.fetch_field_list()
    // this.checkingQuery('/clients')
    //checking school admin ->set schooladmin to true
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Students')
    }
    await this.fetchDisplayFields('Students', this.$store.getters.customerId)
    await this.fetchPLatformTimeZone()
    await this.gridOptions.api.sizeColumnsToFit()
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi

    this.fetchingDynamicFieldAndFilter()

    this.fetchPersonaList()

    //fetching dynamic fields and field and filer list

    // this.fetch_table_filter_data('Accounts')
    this.fetchMainFilter('Students', this.table_name).then(() => {
      this.gridOptions.api.sizeColumnsToFit()
    })
    /* const queryParams = this.$route.query || {}
    this.query_page.page = queryParams.page || 1
    this.query_page.limit = queryParams.limit || 10 */
    // this.query_page.filter_id = queryParams.limit
    // this.fetch_leads_active_status()

    this.gridApi = this.gridOptions.api

    // Object.assign(this.gridApi, this.isRowSelectable)

  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  methods: {
    slugify (string) {
      return string ? string
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '') : ''
    },
    closeRearrangementModal (value) {
      if (value) {
        this.columnRearrangementModal = false
      }
    },
    openConfirmationModal () {
      this.showPopUpBool = true
    },
    async sortFun () {
      try {
        const sortState = this.gridApi.getSortModel()

        if (sortState.length == 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          this.sorting_obj.direction = sortState[0].sort

          this.sorting_obj.field_type = this.gridOptions.columnApi.getColumn(
            sortState[0].colId
          ).colDef.field_type

          const payload = {
            search: this.search,
            customer_id: this.$store.getters.customerId,
            limit: this.pageLimitSet
          }
          this.$vs.loading({
            text: 'Loading...'
          })
          const { data } = await fetchClientBySearch(
            payload,
            this.meta,
            this.sorting_obj
          )
          const table = data.data.clientUser
          this.meta = data.data.meta
          table.map((row, index) => {
            const actionData = {
              toggle: row.basic_details.active_user === '1',
              view: false
            }
            const row_index = index + 1
            const status_list = this.active_status_list
            Object.assign(row, { actionData })
            Object.assign(row, { row_index })
            Object.assign(row, { status_list })
          })
          this.tableData = table
          this.fetchTag(this.platform_module_id)
          this.gridOptions.api.refreshCells()
        }
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    resizeChanges: _.debounce(async function (e) {
      const all_columns = this.gridColumnApi
        .getAllDisplayedColumns()
        .map((column) => column.getColId())
      console.log(e)

      const orders_info = []
      all_columns.forEach((value, key) => {
        orders_info.push({
          field_name: value,
          order: key
        })
      })
      const fields_display_order = []
      this.displayList.forEach((element, key) => {
        fields_display_order.push({
          fields_display_order_id: element.id,
          displayed: element.displayed,
          field_type: element.field_type,
          field_name: element.field_name,
          field_id: element.field_id,
          order: key,
          field_label: element.field_label,
          is_child: element.is_child,
          is_static: element.is_static,
          input_type: element.input_type,
          column_width:
            element.field_label == e.column.colDef.headerName
              ? e.column.actualWidth
              : element.column_width
        })
        // }
      })

      //Final payload object for re-arrangement API
      const payload = {
        fields_display_order,
        customer_id: this.$store.getters.customerId,
        from_list: '0',
        type: 'Students'
      }


      const allGridColumns = this.gridOptions.columnApi.getAllGridColumns()
      this.columnDefsBackup = allGridColumns.map((ele) => {
        return ele.colDef
      })

      //Finally calling API to save column by providing the payload generated from the above codes and logic
      this.rearrangeColumn(payload)
    }, 1000),
    ...mapActions([
      'SET_CLIENT_DELETE_ID',
      'SET_VIEW_CLIENT_SIDEBAR',
      'SET_VIEW_CLIENT_SIDEBAR_DATA',
      'SET_CLIENT_TOGGLE_DATA'
    ]),

    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        const payload = {
          search: vm.search,
          customer_id: vm.$store.getters.customerId,
          limit: vm.meta.limit
        }
        vm.$vs.loading({
          text: 'Loading...'
        })
        vm.meta.current_page = 1

        const { data } = await fetchClientBySearch(
          payload,
          vm.meta,
          vm.sorting_obj
        )
        const table = data.data.clientUser
        vm.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.basic_details.active_user === '1',
            view: false
          }
          const row_index = index + 1
          const status_list = vm.active_status_list
          Object.assign(row, { actionData })
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
        })
        vm.tableData = table
        vm.fetchTag(vm.platform_module_id)
      } catch (e) {
        console.log(e)
      } finally {
        vm.$vs.loading.close()
      }
    }, 1500),
    checkIfRequiredField (params) {
      const { headerName } = params
      const requiredFields = [
        'First Name',
        'Last Name',
        'Email',
        'Phone',
        'Role Name',
        'Timezone'
      ]
      if (requiredFields.includes(headerName)) {
        return true
      } else {
        return false
      }
    },
    async exportApi () {
      const data = await exportApiDownload(
        this.$store.getters.customerId,
        'client'
      )
      this.downloadItem(data.data.data.url, data.data.data.name)
    },
    downloadItem (url, label) {
      axios
        .get(url, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'mime' })
          // const blob = new Blob([response.data], { type: 'application/pdf' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          //link.download = `${label}.${url.split('.')[url.split('.').length - 1]}`
          link.download = `${label}`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    closeModal (value) {
      if (value) {
        this.columnRearrangementModal = false
      }
    },
    fetchingDynamicFieldAndFilter () {
      const customField = this.fetch_customfields_list('Client')
      customField.then((responseData) => {
        if (responseData) {
          this.fetchFieldAndFilterList('Students', this.table_name) //this is fetching dynamic field and static field for filter modules
        }
      })
    },
    excelModal () {
      this.excelPopUp = true
    },
    uploadSuccess (success) {
      if (success) {
        this.excelPopUp = false
        this.searchByfilter()
      }
    },
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(4, customerId,  {table_name:this.table_name})
        //

        this.staticFields = data.data.module_fields
        this.staticChildFields = data.data.module_child_fields

        //
      } catch (e) {}
    },
    handleExport () {
      let exportURL = `${process.env.VUE_APP_API_URL}client_csv_download?`
      const BulkSelected = this.getSelectedRows()

      for (let i = 0; i < BulkSelected.length; i++) {
        if (parseInt(BulkSelected[i].basic_details.active_user) === 1) {
          if (typeof BulkSelected[i + 1] === 'undefined') {
            exportURL += `client_user_id[]=${BulkSelected[i].basic_details.client_users_id}`
          } else {
            exportURL += `client_user_id[]=${BulkSelected[i].basic_details.client_users_id}&`
          }
        }
      }
      //window.open(exportURL, '_blank')
      this.openInNewTab(
        `${exportURL}&customer_id=${this.$store.getters.customerId}`
      )
    },
    openInNewTab (href) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        href
      }).click()
    },
    resetSearch () {
      this.select_filter_id = null
      this.tagSelected = []
      this.searchByClientType = ''
      this.search = ''
      this.handlePageChange(1)
    },
    searchByfilter () {
      const tags = this.tagSelected.map((element) => {
        return element.id
      })

      const payload = {
        client_type: this.searchByClientType,
        tag_ids: tags
      }

      this.fetch_list(payload)
    },
    addClient () {
      this.addSideBar = true
      document.body.classList.add('overflow-hidden')
    },
    columnRearrangement () {
      this.columnRearrangementModal = true
      // document.body.classList.add('overflow-hidden')
    },
    abc (index) {
      const is_active = this.sameasparentAddress.findIndex(
        (item) => item === `child_${index}`
      )

      if (is_active > -1) {

        this.client.children[index].address1 = this.client.address1
        this.client.children[index].address1 = this.client.address1
        this.client.children[index].address2 = this.client.address2
        this.client.children[index].state = this.client.state
        this.client.children[index].zip = this.client.zip
        this.client.children[index].city = this.client.city
        this.client.children[index].platform_customer_countries_id =
          this.client.platform_customer_countries_id
        this.client.children[index].platform_timezone_id =
          this.client.platform_timezone_id
      } else {
        this.client.children[index].address1 = ''
        this.client.children[index].address1 = ''
        this.client.children[index].address2 = ''
        this.client.children[index].state = ''
        this.client.children[index].zip = ''
        this.client.children[index].city = ''
        this.client.children[index].platform_customer_countries_id = ''
        this.client.children[index].platform_timezone_id = ''
      }
    },
    bulkMailAdd () {
      const BulkSelected = this.getSelectedRows()
      const mail_ids = BulkSelected.filter((ele) => {
        return ele.basic_details.active_user === '1'
      }).map((ele) => {
        return ele.basic_details.email
      })

      this.selected_lead_is = BulkSelected.map((ele) => {
        return ele.basic_details.client_users_id
      })
      this.mail_id = mail_ids
    },
    async mail_body (mail_details) {
      const payload = {
        client_ids: this.selected_lead_is,
        header: mail_details[1],
        body: mail_details[2],
        customer_id: this.$store.getters.customerId
      }
      const { data } = await bulkEmailApi(payload)
      this.bulkEmailModal = false
      this.$vs.notify({
        title: 'Success',
        text: 'Email sent Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    async bulkupdatelist (update_list) {
      try {
        const BulkSelected = this.getSelectedRows()

        const updated_ids = []
        for (let i = 0; i < BulkSelected.length; i++) {
          if (BulkSelected[i].basic_details.active_user === '1') {
            updated_ids.push(BulkSelected[i].basic_details.client_users_id)
          }
          // }
        }

        if (updated_ids.length === 0) {
          this.$vs.notify({
            title: 'Warning',
            text: 'Selected rows are non-actionable',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        } else {
          const payload = {
            client_ids: updated_ids,
            customer_id: this.$store.getters.customerId,
            field_name: update_list[0],
            value: update_list[1]
          }
          bulkUpdateApi(payload).then((data) => {
            if (
              update_list[0] === 'first_name' ||
              update_list[0] === 'last_name' ||
              update_list[0] === 'middle_name'
            ) {
              const newRowData = this.tableData.map((row) => {
                if (updated_ids.includes(row.basic_details.client_users_id)) {
                  row.basic_details[update_list[0]] = data.data.data.value
                }
                return row
              })
              this.tableData = newRowData
            } else if (update_list[0] === 'platform_customer_countries_id') {
              const newRowData = this.tableData.map((row) => {
                if (updated_ids.includes(row.basic_details.client_users_id)) {
                  row.basic_details.address[update_list[0]] =
                    data.data.data.value
                  this.countryList.forEach((country) => {
                    if (data.data.data.value === country.id) {
                      row.basic_details.address.country.id =
                        data.data.data.value
                      row.basic_details.address.country.country_name =
                        country.country_name
                    }
                  })
                }
                return row
              })
              this.tableData = newRowData
            } else if (update_list[0] === 'platform_timezone_id') {
              const newRowData = this.tableData.map((row) => {
                if (updated_ids.includes(row.basic_details.client_users_id)) {
                  row.basic_details.address[update_list[0]] =
                    data.data.data.value
                  this.platformTimeZone.forEach((item) => {
                    if (data.data.data.value === item.timezone_id) {
                      row.basic_details.address.timezone.timezone_id =
                        data.data.data.value
                      row.basic_details.address.timezone.timezone =
                        item.timezone
                    }
                  })
                }
                return row
              })
              this.tableData = newRowData
            } else if (
              ['address1', 'address2', 'city', 'zip', 'state'].includes(
                update_list[0]
              )
            ) {
              const newRowData = this.tableData.map((row) => {
                if (updated_ids.includes(row.basic_details.client_users_id)) {
                  row.basic_details.address[update_list[0]] =
                    data.data.data.value
                }
                return row
              })
              this.tableData = newRowData
            } else {
              const newRowData = this.tableData.map((row) => {
                if (updated_ids.includes(row.basic_details.client_users_id)) {
                  row[update_list[0]] = data.data.data.value
                }
                return row
              })
              this.tableData = newRowData
            }
          })
          this.bulkupdateModal = false
        }
      } catch (e) {}
    },
    async fetchDisplayFields (moduleName, customerId) {
      //
      try {
        const payload = {
          customer_id: customerId,
          fetch_status: 'display',
          type: moduleName,
          table_name:this.table_name
        }
        const { data } = await fetchField(payload)
        const displayList = data.data.results
        this.displayList = data.data.results
        let displayColomns = []
        if (displayList.length === 0) {
          displayColomns = this.staticField
          this.displayListofdata = this.staticDisplayField
        } else {
          this.displayListofdata = displayList
          for (const item of displayList) {
            if (item.field_type === 'dynamic') {
              if (item.input_type === 'datetime') {
                const _tempObj = {
                  headerName: item.field_label,
                  field: item.field_name,
                  table_name:item.table_name,
                  sortable: true,
                  field_type: item.field_type,
                  filter: false,
                  minWidth: item.column_width,
                  cellRendererFramework: 'DynamicDate',
                  CellRendererParams: item.field_name,
                  editable: false
                }
                displayColomns.push(_tempObj)
              } else if (item.input_type === 'boolean') {
                const _tempObj = {
                  headerName: item.field_label,
                  sortable: true,
                  table_name:item.table_name,
                  field_type: item.field_type,
                  field: item.field_name,
                  filter: false,
                  minWidth: item.column_width,
                  cellRendererFramework: 'DynamicBoolean',
                  CellRendererParams: item.field_name,
                  editable: true,
                  filterParams: { Update_client: this.Update_client }
                }
                displayColomns.push(_tempObj)
              } else if (item.input_type === 'select') {
                const _tempObj = {
                  sortable: true,
                  field_type: item.field_type,
                  table_name:item.table_name,
                  headerName: item.field_label,
                  field: item.field_name,
                  filter: false,
                  minWidth: item.column_width,
                  cellRendererFramework: 'DynamicSelect',

                  CellRendererParams: {
                    item_name: item.field_name,
                    custom_fields: this.custom_fields.filter((ele) => {
                      if (ele.input_type === 'select') {
                        return ele
                      }
                    })
                  },
                  editable: true,
                  filterParams: { Update_client: this.Update_client }
                }
                displayColomns.push(_tempObj)
              } else if (
                item.input_type !== 'datetime' &&
                item.input_type !== 'boolean' &&
                item.input_type !== 'select'
              ) {
                const _tempObj = {
                  input_type: item.input_type,
                  headerName: item.field_label,
                  table_name:item.table_name,
                  field: item.field_name,
                  filter: false,
                  minWidth: 150,
                  sortable: true,
                  field_type: item.field_type,
                  editable: (params) => {
                    if (
                      item.input_type !== 'checkbox' &&
                      item.input_type !== 'multiselect' &&
                      item.input_type !== 'radio'
                    ) {
                      return true
                    } else {
                      return false
                    }
                  }
                }
                displayColomns.push(_tempObj)
              }
            } else if (['last_name', 'middle_name'].includes(item.field_name)) {
              const _tempObj = {
                field_type: item.field_type,
                headerName: item.field_label,
                field: `basic_details.${item.field_name}`,
                filter: false,
                table_name:item.table_name,
                sortable: true,
                minWidth: item.column_width,
                editable: (params) => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user == '1') {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (item.field_name.includes('mobile')) {
              const _tempObj = {
                headerName: item.field_label,
                field: `basic_details.${item.field_name}`,
                filter: false,
                sortable: true,
                table_name:item.table_name,
                field_type: item.field_type,
                minWidth: item.column_width,
                cellRendererFramework: 'PhoneImageCell',
                editable: (params) => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user == '1') {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (item.field_name.includes('email')) {
              const _tempObj = {
                headerName: item.field_label,
                field: `basic_details.${item.field_name}`,
                filter: false,
                sortable: true,
                field_type: item.field_type,
                minWidth: item.column_width,
                table_name:item.table_name,
                editable: false
              }
              displayColomns.push(_tempObj)
            }  else if (item.field_name.includes('dob')) {
              const _tempObj = {
                headerName: item.field_label,
                field: `bio.${item.field_name}`,
                filter: false,
                sortable: true,
                table_name:item.table_name,
                field_type: item.field_type,
                minWidth: item.column_width,
                editable: (params) => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user == '1') {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (
              ['address1', 'zip', 'state', 'address2', 'city'].includes(
                item.field_name
              )
            ) {
              const _tempObj = {
                headerName: item.field_label,
                field: `basic_details.address.${item.field_name}`,
                filter: false,
                table_name:item.table_name,
                sortable: true,
                field_type: item.field_type,
                minWidth: item.column_width,
                editable: (params) => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user == '1') {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (
              ['platform_customer_countries_id'].includes(item.field_name)
            ) {
              const _tempObj = {
                headerName: item.field_label,
                field: 'basic_details.address.country.country_name',
                filter: false,
                sortable: true,
                table_name:item.table_name,
                field_type: item.field_type,
                minWidth: item.column_width,
                cellRendererFramework: 'CountryCell',
                filterParams: {
                  country: this.countryList,
                  Update_client: this.Update_client
                },
                editable: (params) => {
                  if (!this.checkEditPermission()) {
                    return false
                  }
                  if (params.data.basic_details.active_user == '1') {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (['multi_user'].includes(item.field_name)) {
              const _tempObj = {
                headerName: item.field_label,
                field: 'basic_details.user_type',
                table_name:item.table_name,
                filter: false,
                sortable: true,
                editable: false,
                field_type: item.field_type,
                minWidth: item.column_width
              }
              displayColomns.push(_tempObj)
            } else if (['created_at'].includes(item.field_name)) {
              const _tempObj = {
                headerName: item.field_label,
                table_name:item.table_name,
                field: 'basic_details.created_at',
                filter: false,
                sortable: true,
                field_type: item.field_type,
                minWidth: item.column_width,
                cellRendererFramework: 'CreatedAtCell'
              }
              displayColomns.push(_tempObj)
            } else if (['platform_timezone_id'].includes(item.field_name)) {
              const _tempObj = {
                headerName: item.field_label,
                table_name:item.table_name,
                field: 'basic_details.address.timezone.timezone',
                filter: false,
                sortable: true,
                field_type: item.field_type,
                minWidth: item.column_width
              }
              displayColomns.push(_tempObj)
            } else if (['dob', 'gender'].includes(item.field_name)) {
              const _tempObj = {
                headerName: item.field_label,
                table_name:item.table_name,
                field: 'basic_details.bio',
                sortable: true,
                filter: false,
                minWidth: item.column_width
              }
              displayColomns.push(_tempObj)
            } else if (item.field_label === 'First Name') {
              const _tempObj = {
                headerName: 'Full Name',
                table_name:item.table_name,
                field: `basic_details.${item.field_name}`,
                filter: false,
                sortable: true,
                field_type: item.field_type,
                minWidth: item.column_width,
                cellRendererFramework: 'FullNameCell',
                editable: false
              }
              displayColomns.push(_tempObj)
            } else {
              const _tempObj = {
                headerName: item.field_label,
                field: item.field_name,
                table_name:item.table_name,
                filter: false,
                sortable: true,
                field_type: item.field_type,
                minWidth: item.column_width
              }
              displayColomns.push(_tempObj)
            }
          }
          const staticField1 = {
            headerName: '',
            minWidth: 45,
            field: 'isSelected',
            filter: false,
            sortable: false,
            resizable: false,
            checkboxSelection: (params) => {
              return true
              /* if (params.data.is_active === '1') {
                return true
              } else {
                return false
              } */
            },
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true
          }

          // const fullname = {
          //   headerName: 'Full Name',
          //   field: 'fullname',
          //   filter: true,
          //   minWidth: 150,
          //   resizable: true,
          //   editable: false,
          //   sortable: true,
          //   field_type: 'system',
          //   cellRendererFramework: 'FullNameCell',
          //   cellStyle: { color: 'blue' },
          //   suppressMovable: false
          // }
          // displayColomns.unshift(fullname)

          const staticField2 = {
            headerName: '#',
            field: 'row_index',
            filter: false,
            minWidth: 100,
            maxWidth: 100,
            sortable: false,
            editable: false,
            valueGetter:(params) => {
              return ((this.meta.limit * (this.meta.current_page - 1)) + params.node.rowIndex + 1)
            }
          }
          displayColomns.unshift(staticField2)
          displayColomns.unshift(staticField1)
        }

        const tags = {
          headerName: 'Tags',
          field: 'tags',
          sortable: true,
          editable: false,
          cellRendererFramework: 'TagShow',
          filter: false,
          minWidth: 150,
          field_type: 'system',
          cellClass: 'unset-line-height-cell',
          suppressMovable: true
        }
        displayColomns.push(tags)

        const actionField5 = {
          headerName: 'Courses',
          minWidth: 110,
          maxWidth: 110,
          editable: false,
          filter: false,
          sortable: true,
          field_type: 'system',
          cellRendererFramework: 'CoursesListAction'
        }
        displayColomns.push(actionField5)

        const actionField6 = {
          headerName: 'Teachers',
          minWidth: 110,
          maxWidth: 110,
          editable: false,
          sortable: true,
          field_type: 'system',
          filter: false,
          cellRendererFramework: 'TeachersListAction'
        }
        displayColomns.push(actionField6)

        const actionField = {
          headerName: 'Active',
          field: 'actionData',
          sortable: false,
          editable: false,
          filter: false,
          cellRendererFramework: 'ToggleActions',
          minWidth: 90,
          maxWidth: 90,
          suppressMovable: true
          // cellRendererFramework: 'CellRendererActions'
        }
        displayColomns.push(actionField)

        if (this.checkEditPermission()) {
          const actionField1 = {
            headerName: 'Actions',
            field: 'actionData',
            minWidth: 100,
            sortable: false,
            maxWidth: 100,
            editable: false,
            filter: false,
            // cellRendererFramework: "EditActions",
            cellRendererFramework: 'CellRendererActions'
          }
          displayColomns.push(actionField1)
        }

        // if (this.checkDeletePermission()) {
        //   const actionField2 = {
        //     headerName: "Delete",
        //     field: "actionData",
        //     minWidth: 100,
        //     editable: false,
        //     filter: false,
        //     cellRendererFramework: "DeleteActions",
        //     // cellRendererFramework: 'CellRendererActions'
        //   };
        //   displayColomns.push(actionField2);
        // }
        // const actionField3 = {
        //   headerName: "Preview",
        //   field: "actionData",
        //   minWidth: 100,
        //   editable: false,
        //   filter: false,
        //   cellRendererFramework: "PreviewActions",

        //   // cellRendererFramework: 'CellRendererActions'
        // };

        // displayColomns.push(actionField3);

        // const actionField4 = {
        //   headerName: "Send Invitation",
        //   minWidth: 100,
        //   editable: false,
        //   filter: false,
        //   cellRendererFramework: "EmailAction",

        //   // cellRendererFramework: 'CellRendererActions'
        // };

        // displayColomns.push(actionField4);

        this.columnDefs = displayColomns
        this.columnDefsBackup = displayColomns
        // this.columnDefs.push({headerName: 'New Column'})

        this.gridOptions.api.setColumnDefs(displayColomns)
        this.gridOptions.api.refreshCells({ force: true })
      } catch (e) {
        console.warn(e)
      }
    },
    async fetchPersonaList () {
      try {
        const { data } = await getPersonaDetails()

        this.personaList = data.data.clientPersona
      } catch (e) {
        console.warn(e)
      }
    },
    handleAddMinor () {
      //add child function
      const payload = {
        first_name: null,
        middle_name: null,
        last_name: null,
        email: null,
        mobile: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        platform_customer_countries_id: 1,
        platform_timezone_id: null,
        hide: true
      }
      this.client.children.push(payload)
    },
    async fetchCountry (event) {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {}
    },

    handledeleteChild (index) {
      //remove child function
      this.client.children.splice(index, 1)
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      //
      return selectedData
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    handleBulkDelete () {
      const BulkSelected = this.getSelectedRows()
      const deleting_ids = []
      for (let i = 0; i < BulkSelected.length; i++) {
        if (BulkSelected[i].basic_details.active_user === '0') {
          if (BulkSelected[i].basic_details.user_type === 'Parent') {
            if (BulkSelected[i].children.length > 0) {
              if (this.checkAllChildDeactive(BulkSelected[i].children)) {
                deleting_ids.push(
                  BulkSelected[i].basic_details.client_users_id
                )
              } else {
                this.$vs.notify({
                  title: 'Warning',
                  text: 'Deactive all minor first',
                  ...this.warnProp()
                })
              }
            } else {
              deleting_ids.push(BulkSelected[i].basic_details.client_users_id)
            }
          } else {
            deleting_ids.push(BulkSelected[i].basic_details.client_users_id)
          }
        }
        // }
      }
      if (deleting_ids.length === 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Selected rows are non-actionable',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        const payload = {
          client_user_id: deleting_ids
        }
        //
        deleteClient(payload, this.$store.getters.customerId)
          .then((data) => {
            const table = this.tableData
            for (const delete_id_itr of deleting_ids) {
              for (let i = 0; i < table.length; i++) {
                if (delete_id_itr === table[i].basic_details.client_users_id) {
                  table.splice(i, 1)
                }
              }
            }
            table.map((row, index) => {
              row.row_index = index + 1
            })
            this.tableData = table
            this.isRowSelected = false
            this.showPopUpBool = false

            if (this.tableData.length === 0 && !this.meta.next_page_url) {
              this.handlePageChange(this.meta.current_page - 1)
            } else {
              this.handlePageChange(this.meta.current_page)
            }

            this.$vs.notify({
              title: 'Success',
              text: 'Bulk deletion successfull',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })
          .catch((e) => {})
      }

      // bul
      // for( let )
    },
    showDetails (data) {
      this.viewSideBar = true
      this.selected_data = data
    },

    async fetch_list (payload, params = null) {
      let text = ''
      if (params === null) {
        text = 'Fetching Students List ...'
      } else {
        text = 'Fetching Students List ...'
      }
      this.$vs.loading({
        text
      })
      //
      const customer_id =
        this.$store.state.LoginStorage.user_details.customer_id
      try {
        const { data } = await clientList(
          payload,
          this.meta.current_page,
          customer_id,
          params,
          this.pageLimitSet
        )

        const table = data.data.clientUser
        this.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.basic_details.active_user === '1',
            view: false
          }
          const row_index = index + 1
          const status_list = this.active_status_list
          Object.assign(row, { actionData })
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
        })
        this.tableData = table
        this.fetchTag(this.platform_module_id)
        // firstData:[],
        // this.firstData = table
        // this.allData = table
        //
        //
      } catch (e) {
      } finally {
        this.$vs.loading.close()
      }
    },
    get_table_id (id, table) {
      //id => number, table => array ... matching.
      for (let i = 0; i > table.length; i++) {
        if (table[i].basic_details.operation_user_id === id) {
          return i
        }
      }
    },
    handleDelete (tableList) {
      if (tableList.isActionable) {
        const table = this.tableData
        const rowId = tableList.basic_details.operation_user_id
        let deleted_index = null

        for (let i = 0; i < table.length; i++) {
          if (rowId === table[i].basic_details.operation_user_id) {
            deleted_index = i
            break
          }
        }
        table.splice(1, deleted_index)
        this.tableData = table
        this.$vs.notify({
          title: 'Success',
          text: 'Client Deletion Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Cant Delete Client, Turn on Action Button',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    create_client () {
      this.api_response_message_show = false
      const validateParent = this.$validator.validateAll('add')
      const childDynamicComponent =
        this.$refs.children.$validator.validateAll('add')
      const validateAll = Promise.all([validateParent, childDynamicComponent])

      validateAll.then((valid) => {
        if (!valid.includes(false)) {
          try {
            const object1 = {
              dynamic_fields: {}
            }
            object1.dynamic_fields = this.dynamicFormObject
            // const payload = this.client

            const payload = Object.assign({}, this.client, object1)

            if (payload.multi_user === 0) {
              delete payload.children
            }
            const customer_id =
              this.$store.state.LoginStorage.user_details.customer_id
            createClient(payload, customer_id)
              .then((response) => {
                const queryParams = this.$route.query || {}
                const query = {}
                query.page = queryParams.page || 1
                query.limit = queryParams.limit || 10
                this.fetch_list()
                const added = response.data.data.clientUser
                const actionData = {
                  toggle: true,
                  view: false
                }
                Object.assign(added, { actionData })
                const addedarray = [added]
                this.tableData = [...addedarray, ...this.tableData]
                const table = this.tableData

                table.map((row, index) => {
                  row.row_index = index + 1
                })
                this.tableData = table
                this.$validator.errors.clear('Add')
                this.handlcreateSidebar()
                this.$vs.notify({
                  title: 'Success',
                  text: 'Student Created Successfully',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success',
                  time: 8000
                })
              })
              .catch((api_error) => {
                //
                for (const [key, value] of Object.entries(
                  api_error.data.errors
                )) {
                  this.$vs.notify({
                    title: 'Warning',
                    text: `${value[0]}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                    time: 8000
                  })
                }
              })
          } catch (e) {
            //
          }
        }
      })
    },
    handleViewSidebar () {
      const payload = false
      this.SET_VIEW_CLIENT_SIDEBAR(payload)
      this.SET_VIEW_CLIENT_SIDEBAR_DATA(null)
    },
    handlcreateSidebar () {
      this.addSideBar = false
      document.body.classList.remove('overflow-hidden')
      // this.$validator.errors.clear('Add')
      this.$validator.reset()
      this.client = {
        client_persona_id: null,
        lead_id: null,
        multi_user: 0,
        first_name: null,
        middle_name: null,
        last_name: null,
        email: null,
        mobile: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        platform_customer_countries_id: 1,
        children: [
          {
            first_name: null,
            middle_name: null,
            last_name: null,
            email: null,
            mobile: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            zip: null,
            platform_customer_countries_id: 1,
            hide: true
          }
        ]
      }
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        //
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map((node) => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    handlePageChange (page) {
      if (!this.pageLimitSet) return

      const tags = this.tagSelected.map((element) => {
        return element.id
      })
      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.client_type = this.searchByClientType
      queryPayload.tag_ids = tags
      queryPayload.limit = this.pageLimitSet
      // this.meta.current_page = page
      const pageScroll = document.documentElement.scrollTop
      this.$router
        .replace({ path: '/clients', query: queryPayload })
        .catch(() => {})
        .then(() => {
          document.documentElement.scrollTop = pageScroll
        })
      if (this.select_filter_id === null) {
        this.fetch_list(queryPayload)
      } else if (this.search != '' || this.sorting_obj.attribute != '') {
        this.searchFunPage()
      } else {
        const params = {
          filter_id: this.select_filter_id
        }
        this.fetch_list(queryPayload, params)
      }
    },
    async searchFunPage () {
      try {
        const statusList = await this.active_status_list
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId,
          limit: this.pageLimitSet
        }


        this.$vs.loading({
          text: 'Loading...'
        })
        const { data } = await fetchClientBySearch(
          payload,
          this.meta,
          this.sorting_obj
        )
        const table = data.data.clientUser
        this.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.basic_details.active_user === '1',
            view: false
          }
          const row_index = index + 1
          const status_list = statusList
          Object.assign(row, { actionData })
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
        })
        this.tableData = table
        this.fetchTag(this.platform_module_id)
      } catch (e) {
      } finally {
        this.$vs.loading.close()
      }
    },
    cellSingleClicked (params) {
      if (params.column.colDef.field === 'basic_details.first_name') {
        router.push({
          name: 'profile',
          params: { client_id: params.data.basic_details.client_users_id }
        })
      }
    },
    checkAllChildDeactive (childs) {
      for (const item of childs) {
        if (item.child.active_user === '0') {
          return false
        } else {
          return true
        }
      }
    },

    // async fetch_main_filter () {
    //   const { data } = await get_main_filter('Students')
    //
    //   const tempdata = data.data.filters
    //   this.user_main_filter = [this.user_main_filter, ...tempdata]
    //   // this.user_main_filter = data.data.filters
    // },
    getFilterByLead () {
      if (this.select_filter_id === null) {
        this.fetch_list()
      } else {
        const params = {
          filter_id: this.select_filter_id
        }
        this.fetch_list(null, params)
      }
    },
    async Update_client (data, fulladdress) {
      const user_id = data.user_id
      const payload = {
        updateField: fulladdress
      }
      if (
        data.colId === 'address1' ||
        data.colId === 'address2' ||
        data.colId === 'state' ||
        data.colId === 'city' ||
        data.colId === 'zip' ||
        data.colId === 'platform_customer_countries_id'
      ) {
        const keyName = data.colId
        fulladdress[keyName] = data.fieldvalue
        payload.updateField = {
          address: fulladdress
        }
      } else if (data.is_dynamic) {
        payload.dynamic_fields = {
          [data.colId]: data.fieldvalue
        }
      } else {
        payload.updateField = {
          [data.colId]: data.fieldvalue
        }
      }
      try {
        const customer_id = this.$store.getters.customerId
        const { data } = await updateClient(user_id, payload, customer_id)
        this.$vs.notify({
          title: 'Success',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (api_error) {
        this.$vs.notify({
          title: 'Warning',
          text: api_error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      }
    },
    overallSearch () {
      this.overallSearchHolder = !this.overallSearchHolder
    },
    handleColumnHideShow (params) {
      const allowHide = this.checkIfRequiredField(params.column.colDef)
      if (allowHide) {
        this.columnDefs = []
        setTimeout(() => {
          this.gridOptions.api.setColumnDefs(this.columnDefsBackup)
          this.gridOptions.api.sizeColumnsToFit()
        }, 0)
      } else {
        this.handleRearrangement(params, true)
      }
    },
    handleRearrangement (param, fromHandleColumnHideShow) {

      //Taking all existing columns from ag-grid table showing now to get order and field name information
      const all_columns = this.gridColumnApi
        .getAllDisplayedColumns()
        .map((column) => column.getColId())

      // Generating above columns orders (Column Index) and field_name object.
      // Here all the Ag-grid column received are already in arranged or sorted order by ag-grid itself after the rearrangement we do
      const orders_info = []
      all_columns.forEach((value, key) => {
        orders_info.push({
          field_name: value,
          order: key
        })
      })
      //Just providing a 100 milisecond for loop above to be completed before further process, it's quite important here
      setTimeout(() => {
        let column_rearranged = null
        //Taking currect rearranged column information by ag-grid 'columnMoved' event to give it a new order
        column_rearranged = this.displayList.filter((x) => {
          return x.field_name === this.getCorrectFieldName(param.column.colId)
        })
        //Check if event fired is ag-grid columnVisible (fromHandleColumnHideShow)
        if (fromHandleColumnHideShow) {
          column_rearranged = this.displayList.filter((x) => {
            return (
              x.field_name === this.getCorrectFieldName(param.column.colId)
            )
          })
        }

        // const old_order = column_rearranged[0].order
        // const new_order = param.toIndex - 1

        //Checking if currect rearranged column is inside the array of column to show given by backend then proceed else just skip
        if (column_rearranged.length) {


          column_rearranged[0].order =
            orders_info.filter((x) => {
              return x.field_name === param.column.colId
            }).order - 1


          //Just delete old information since we need new order infor, we can also just change order property here,
          //I just removed and added again with new order information, both will work here
          this.displayList.splice(
            this.displayList.findIndex(
              (x) => x.field_name === this.getCorrectFieldName(param.column.colId)
            ),
            1
          )

          //Adding again the removed column above, with new order info
          this.displayList.unshift(column_rearranged[0])

          const fields_display_order = []
          this.displayList.forEach((element) => {
            //If all currecnt ag-grid column is inside the array of column to show given by backend then proceed else just skip
            const found = orders_info.find((x) => {
              return (
                x.field_name === element.field_name ||
                element.field_name === this.getCorrectFieldName(x.field_name)
              )
            })

            // If all the other column received from ag-grid is in array of column to show,
            //proceed and make a required payload for API call to save column re-arrangement information

            if (found) {
              //Adding new order returned by ag-grid for an element in a loop
              element.order = found.order - 1

              //Making required payload object form the API to save column re-arrangement
              //All the information is already in the is in array of column to show received from backend,
              //just found it and added it make payload object

              fields_display_order.push({
                fields_display_order_id: element.id,
                displayed: element.displayed,
                field_type: element.field_type,
                field_name: element.field_name,
                field_id: element.field_id,
                order: element.order,
                field_label: element.field_label,
                is_child: element.is_child,
                is_static: element.is_static,
                input_type: element.input_type
              })
            }
          })

          //Final payload object for re-arrangement API
          const payload = {
            fields_display_order,
            customer_id: this.$store.getters.customerId,
            from_list: '0',
            type: 'Students',
            table_name: 'student_list'
          }

          const allGridColumns = this.gridOptions.columnApi.getAllGridColumns()
          this.columnDefsBackup = allGridColumns.map((ele) => {
            return ele.colDef
          })

          //Finally calling API to save column by providing the payload generated from the above codes and logic
          this.rearrangeColumn(payload)
        } else {
        //
        }
      }, 200)
    },
    async rearrangeColumn (payload) {
      try {
        await arrangeColumn(payload)
      } catch (e) {
        console.error(e)
      }
    },
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId === 'basic_details.company') {
        field_name = 'company'
      } else if (
        colId === 'basic_details.phone.phone' ||
        colId === 'basic_details.phone.phone_1'
      ) {
        field_name = 'phone'
      } else if (
        colId === 'basic_details.address.address1' ||
        colId === 'basic_details.address.address1_1'
      ) {
        field_name = 'address1'
      } else if (
        colId === 'basic_details.address.address2' ||
        colId === 'basic_details.address.address2_1'
      ) {
        field_name = 'address2'
      } else if (
        colId === 'basic_details.address.zip' ||
        colId === 'basic_details.address.zip.zip_1'
      ) {
        field_name = 'zip'
      } else if (
        colId === 'basic_details.address.city' ||
        colId === 'basic_details.address.city.city_1'
      ) {
        field_name = 'city'
      } else if (
        colId === 'basic_details.address.state' ||
        colId === 'basic_details.address.state_1'
      ) {
        field_name = 'state'
      } else if (
        colId === 'basic_details.email.email' ||
        colId === 'basic_details.email.email_1'
      ) {
        field_name = 'email'
      } else if (
        colId === 'basic_details.address.country.country_name' ||
        colId === 'basic_details.address.country.country_name_1'
      ) {
        field_name = 'platform_customer_countries_id'
      } else if (
        colId === 'basic_details.last_name' ||
        colId === 'basic_details.last_name_1'
      ) {
        field_name = 'last_name'
      } else if (
        colId === 'basic_details.first_name' ||
        colId === 'basic_details.first_name_1'
      ) {
        field_name = 'first_name'
      } else if (
        colId === 'basic_details.phone.mobile' ||
        colId === 'basic_details.phone.mobile_1' || colId === 'basic_details.mobile_1'
      ) {
        field_name = 'mobile'
      } else if (
        colId === 'basic_details.created_at' ||
        colId === 'basic_details.created_at_1'
      ) {
        field_name = 'created_at'
      } else if (colId === '0') {
        field_name = 'user_roles_id'
      } else if (colId === 'basic_details.roles[0].user_role_id') {
        field_name = 'user_role_id'
      } else if (colId === 'basic_details.address.state') {
        field_name = 'state'
      } else if (
        colId === 'basic_details.bio' ||
        colId === 'basic_details.bio_1'
      ) {
        field_name = 'dob'
      } else if (
        colId === 'basic_details.email' ||
        colId === 'basic_details.email_1'
      ) {
        field_name = 'email'
      } else if (colId === 'tags_1') {
        field_name = 'tags'
      } else if (
        colId === 'basic_details.address.timezone.timezone' ||
        colId === 'basic_details.address.timezone.timezone_1'
      ) {
        field_name = 'platform_timezone_id'
      } else if (
        colId === 'basic_details.user_type'
      ) {
        field_name = 'multi_user'
      }

      return field_name
    }
  },
  computed: {
    ...mapGetters([
      'get_client_deleted_id',
      'get_client_sidebar_view',
      'get_client_sidebar_data',
      'get_client_toggle_data'
    ]),

    isRowSelectable (rowNode) {
      return rowNode.data.is_active === '1'
    },
    limitedTableList () {
      /*
      let tableList = []
      if (this.pageLimitSet === 'all') {
        tableList = this.tableData
      } else {
        const TableLength = this.tableData.length
        if (this.pageLimitSet >= TableLength) {
          tableList = this.tableData
        } else {
          for (let i = 0; i < this.pageLimitSet; i++) {
            tableList.push(this.tableData[i])
          }
        }
      } */
      // const tableList = this.tableData.splice(0, this.pageLimitSet)
      return this.tableData
    },
    slectMulti () {
      const selectedNodes = this.gridApi
      if (selectedNodes) {
        return this.gridApi.getSelectedNodes
      }
      // return selectedNodes
    },
    getRootUser (params) {
      return 1
    }
    // isRowSelected () {
    //   // const selectedNodes = this.gridApi.getSelectedNodes()

    // }
  },
  beforeRouteLeave (to, from, next) {
    this.addSideBar = false
    this.filterSidebarBoolean = false
    const payload = false
    this.SET_VIEW_CLIENT_SIDEBAR(payload)
    this.SET_VIEW_CLIENT_SIDEBAR_DATA(null)
    setTimeout(() => {
      next()
    }, 0)
  }
}
</script>
<style>
.unset-line-height-cell {
  line-height: unset !important;
}
.add_students_popup .dyn_form .vs-lg-6 {
  width: 100% !important;
}
.add_students_popup .dyn_form > div {
  padding: 0 !important;
  margin-top: 7px !important;
}
.add_students_popup .dyn_form .vs-textarea-primary {
  margin-bottom: 0 !important;
}
.add_students_popup .dyn_form label.con-vs-radio,
.add_students_popup .dyn_form .con-vs-checkbox {
  margin-left: 0 !important;
  margin-right: 10px !important;
}
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /*height: auto !important;*/
  /*position: absolute;*/
  /*top: 12%;*/
}
/* [dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items {
  overflow-y: scroll;
} */
/* .vs-sidebar .vs-sidebar--items {
  overflow-y: scroll !important;
} */

.vs-sidebar .vs-sidebar--items {
  overflow: auto;
}

.add-new-data-sidebar ::v-deep .vs-sidebar--background {
  z-index: 52010;
}
.add-new-data-sidebar ::v-deep .vs-sidebar {
  z-index: 52010;
  width: 400px;
  max-width: 90vw;
}
.flatpickr-calendar.open {
  z-index: 111111111111115 !important;
}

.vs-notifications {
  z-index: 1111111111111151111 !important;
}

.gb-vue-timeline-update__title {
  font-size: 14px !important;
  margin-left: -12px !important;
}

.gb-vue-timeline-update__ago {
  margin-right: -9%;
}
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  box-shadow: 7px 3px 15px #c7c6c6;
}
/* .ag-header-cell {
    padding: 2px !important;
  } */

@media (min-width: 1281px) and (max-width: 1919px) {
  .main-vertical .vx-navbar-wrapper {
    width: calc(100% - 260px);
  }
}
@media (min-width: 1920px) {
  .main-vertical .vx-navbar-wrapper {
    width: 88%;
  }
  /* .ag-grid-table {
    max-height: 350px;
  } */
  .v-nav-menu .vs-sidebar {
    max-width: 12%;
  }
  #content-area.content-area-reduced {
    margin-left: 12%;
  }
  .btn-w-icon i {
    font-size: 25px;
  }
}
</style>
<style scoped>
.custom-btn1 {
  padding: 5px 10px !important;
  font-size: 12px;
  border-radius: 0px;
  font-weight: 600;
}
.ag-pivot-off .ag-header-group-cell {
  /* font-size: 50px; */
  color: red;
}
.ag-grid-table {
  min-height: 250px;
}

li {
  list-style: none;
}

#selectdynamic {
  width: 100%;
  height: 38px;
  border-radius: 4px;
}
#dynamicradio {
  margin-right: 10px;
}

.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}
.required:after {
  content: " *";
  color: red;
}
</style>
